"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ChevronDown } from "lucide-react";
export default function MenuHero() {
  const {
    ref: panelRef,
    isVisible: panelVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative w-full h-screen overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1474184/img/image_ts1ex17q.webp)]" style={{
      backgroundAttachment: "fixed"
    }} />
      {}
      <div className="absolute inset-0 bg-dark-background/40" />
      {}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4">
        {}
        <div ref={panelRef} className={`
            max-w-3xl w-full p-8 md:p-12
            bg-light-background/90 backdrop-blur-md
            rounded-3xl shadow-strong
            text-center
            transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]
            ${panelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}
          `}>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-light mb-4">
            Authentic Mexican Flavors
          </h1>
          <p className="text-lg md:text-xl text-foreground font-sans leading-relaxed">
            Experience the warmth of Texas Margaritas with sizzling fajitas,
            handcrafted tacos, and signature margaritas in a family-friendly
            atmosphere.
          </p>
        </div>

        {}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <ChevronDown className="size-10 text-foreground drop-shadow-lg" strokeWidth={2.5} />
        </div>
      </div>

      <style jsx>{`
        @keyframes bounce {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        .animate-bounce {
          animation: bounce 2s ease-in-out 2;
        }
      `}</style>
    </section>;
}